import $ from 'jquery';
import Modal from '../modules/Modal'
import Form from '../modules/Form'
class Contact extends Form{

    constructor(){

        super();

        this.form = $('#contact-us-form');

        this.button = this.form.find('#contact-submit-button');

        this.events();

    }

    events(){

        this.form.on('submit', this.submitForm.bind(this));
        
    }
    submitForm(event){

        event.preventDefault();

        const data = {
            first_name: this.form.find('input[name="first_name"]').val(),
            last_name: this.form.find('input[name="last_name"]').val(),
            email: this.form.find('input[name="email"]').val(),
            phone: this.form.find('input[name="phone"]').val(),
            message: this.form.find('textarea[name="message"]').val(),
            newsletter_consent: Number(this.form.find('#newsletter_consent').attr("value")),
            nonce: jpfContact.nonce
        }

        this.disableForm();

        this.showprocessMessage();

        $.ajax({
            url: jpfContact.ajax_url,
            type: 'POST',
            data: {
                action: 'jpf_contact',
                formData: JSON.stringify(data)
            },
            success: (response) => {

                if(response.success){

                    this.successMessage(response.message);

                } else {

                    this.failedMessage(response.message);

                }

            },
            error: (xhr, status, error) => {
                console.error('Message send failure:', error);
                this.failedMessage('An error occurred. Please try again later.');
            }
        });

    }
    successMessage(message){

        new Modal({
            header:"Message Sent",
            alert:true,
            content: "Thank you for your message. A member of our team will respond within 24-48 hours.",
            confirm:{
                label:"Ok"
            }      
        })        
        this.removeprocessMessage();
        this.resetForm();

    }
    failedMessage(message){

        new Modal({
            header:"Message Failed",
            alert:true,
            content: message,
            confirm:{
                label:"Ok"
            }      
        }) 
        this.removeprocessMessage();
        this.resetForm();
    }

}
export default Contact;